import { useEffect } from 'react'

/**
 * Sätter document.title per sida — "Sida – Majortipset".
 *
 * SPA:n har en statisk head, så utan det här heter varje flik likadant och
 * historiken blir oläslig. För de publika sidorna (startsidan, /tabell) är
 * titeln dessutom det som står i sökresultatet.
 *
 * Ingen cleanup tillbaka till fallbacken: nästa sida sätter sin egen titel,
 * och en mellanlanding på basnamnet hade bara gett ett blink i fliken.
 */
export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title ? `${title} – Majortipset` : 'Majortipset – tipsspelet för golfens fyra majors'
  }, [title])
}
